<p>{{ hosts.join(', ') }}</p>